<div class="card-body" [ngClass]="{ success: !isWarning, warning: isWarning }">
  <div class="result-img">
    <span class="icon-ic_big_v" [ngClass]="{ 'icon-ic_big_v': !isWarning, 'icon-ic_big_a': isWarning }"></span>
  </div>
  <div *ngIf="!isWarning" class="result-title">
    <p [innerHTML]="title | translate : { code: code | translate }"></p>
    <ng-template [ngIf]="subTitle">
      <p [innerHTML]="subTitle | translate"></p>
    </ng-template>
  </div>
  <button class="btn btn-link" (click)="goToSummary()">{{ "REFERENCE" | translate }} #{{ referenceNumber }}</button>
  <ng-container *ngIf="!isWarning; else warningLayout">
    <div class="result-text">
      <p [innerHTML]="text | translate : { code: code | translate }"></p>
      <p *ngIf="isShowBondPurchaseText" [innerHTML]="'INFO.RESULT.SUCCESS.TEXT.HANDLING_BOND_PURCHASE' | translate"></p>
    </div>
  </ng-container>
</div>
<ng-template #warningLayout>
  <div class="result-text text-error">
    <p [innerHTML]="textWarning | translate : { code: code | translate }"></p>
    <p *ngIf="isShowBondPurchaseText" [innerHTML]="'INFO.RESULT.SUCCESS.TEXT.HANDLING_BOND_PURCHASE' | translate"></p>
    <br />
    <button class="btn btn-link" (click)="contactToSupport()">{{ "BUTTON.CONTACT_SUPPORT" | translate }}</button>
  </div>
</ng-template>
